import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../modal/ModalContainer";
import { Button, Grid, Avatar, Typography, Switch } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import ResponsiveTable from "../table/ResponsiveTable";
import CheckCircle from "@material-ui/icons/CheckCircle";
import image from "../../helper/image";
import { ProfileType, BookingStatusType } from "../../types/enum";
import moment from "moment";
const API_ROOT = process.env.REACT_APP_MAIN_SERVICE_URL;

@inject("venueActStore", "bookingRequestStore", "templateStore", "venueActStore", "profileStore")
@observer
class VenueInvoiceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            isLoading: false,
            availableActs: undefined,
            actData: [],
            isSubmit: false
        };
    }

    componentDidMount() {
        const { currentProfile } = this.props.profileStore;
    }

    componentWillReceiveProps(nextProps) {
        const { currentProfile } = this.props.profileStore;
        if (this.props.venue !== nextProps.venue) {
            this.mapToRowData(nextProps.actData)
           
        }
    }

    handleSubmit = () => {
        this.props.venueActStore.updateVenueActInvoiceTypeFromAct(this.state.actData).then((response) => {
            this.setState({
                isSubmit: true
            })
            var actDatas = this.state.actData
            response.forEach(data => {
                var actData = actDatas.find(x => x.id == data.venueActId);
                if (actData) {
                    actData.isSuccess = data.isSuccess;
                }
                
            });

            this.mapToRowData(actDatas)
            
            // this.onClose()
        })
        
    }

    handleSwitchOn = row => {
        var data = this.props.actData
        data.forEach(item => {
            if(item.id == row.id){
                item.act.invoiceType = item.act.invoiceType ? 0 : 1,
                item.isChange = true
            }
            
        });
        
        this.mapToRowData(data)
        
     }  

  

    columns = [{ key: "act", label: "Act Name" }, { key: "lineUpCount", label: "Act Type" }, {key: "invoiceType", label:"Invoice Type"}];

    columnsSubmit = [{ key: "act", label: "Act Name" }, { key: "lineUpCount", label: "Act Type" }, {key: "invoiceType", label:"Invoice Type"}, {key: "isSuccess", label:"Confirmation"}];


     mapToRowData = rows => {
            var rowData = [];
            const { booking } = this.props;
            const { selectedRow } = this.state;
            rows.forEach(row => {
                let data = {};
                data.actData = row;
    
                data.id = row.actId;
                data.isSuccess =  row.isChange ? row.isSuccess ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div> : "Failed to update" : null             
                // data.disableCheckbox =
                //     booking.status === BookingStatusType.Declined.ordinal &&
                //     !booking.cancelledBy &&
                //     selectedRow.length > 0 &&
                //     selectedRow[0].actData.id !== row.id;
    
                // data.disableCheckbox =
                //     // booking.status === BookingStatusType.Declined.ordinal &&
                //     selectedRow.length > 0 &&
                //     selectedRow[0].actData.actId !== row.actId;
    
                data.act = (
                    <Grid container alignContent="center" alignItems="center">
                        <Grid item xs={4}>
                            <Avatar
                                alt={row.act.fullName}
                                src={image.getProfileImage(row.act)}
                                style={{
                                    width: 40,
                                    height: 40
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subheading" noWrap>
                                {row.act.fullName}
                            </Typography>
                        </Grid>
                    </Grid>
                );
    
                data.lineUpCount = this.props.venueActStore.getLineUpCounts(row.act.lineUpCount);

                data.invoiceType = (
                    <Fragment>
                      <Switch checked={row.act.invoiceType} onChange={() => this.handleSwitchOn(row)} value="hideToolbar" /> Act Player Invoices paid by Venue
                    </Fragment>
                )
    
                rowData.push(data);
            });
    
            this.setState({
                ...this.state,
                rowData: rowData,
                actData: rows
            });
        };

   


    handleClose = () => {
        this.setState(
            {
                rowData: [],
                isLoading: false,
                isSubmit: false,
                actData: []
            },
            () => {
                this.props.onClose();
            }
        );
    };

    render() {
        const { booking } = this.props;
        return (
            <ModalContainer
                title={`Invoice Settings for Acts Booked by ${this.props.venue?.profileName}`}
                open={this.props.open}
                onClose={this.handleClose}
                maxWidth="md"
                fullScreen={false}
                isLoading={this.state.isLoading}
            >
                <DialogContent>
                    <Typography component="p" >Enabling this feature will result in your act player invoices being sent to the venue for payment.</Typography>
                    <ResponsiveTable
                        columns={this.state.isSubmit ? this.columnsSubmit : this.columns}
                        rows={this.state.rowData}
                        title="List of Acts"
                    />
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose}>Close</Button>
                    <Button
                        id="confirm-send-request"
                        color="primary"
                        onClick={this.handleSubmit}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default VenueInvoiceModal;
